import { render, staticRenderFns } from "./returnc-caseclosure.vue?vue&type=template&id=6c3811f0&scoped=true"
import script from "./returnc-caseclosure.vue?vue&type=script&lang=ts"
export * from "./returnc-caseclosure.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3811f0",
  null
  
)

export default component.exports